import type { Writable } from 'svelte/store';
import { writable } from 'svelte/store';
import type { ButtonOrLinkAppearance } from '../types/props';

type PageLoaderStore = {
	open: (_?: Partial<PageLoaderOptions>) => void;
	close: () => void;
};

type PageLoaderOptions = {
	isOpen: boolean;
	color: string;
	textColor: string;
	ctaColor: string;
	ctaAppearance: ButtonOrLinkAppearance;
	message?: string;
	ctaLabel?: string;
	ctaAction?: () => void;
};

const pageLoaderOptionsDefault: PageLoaderOptions = {
	isOpen: false,
	color: 'primary',
	textColor: 'white',
	ctaColor: 'white',
	ctaAppearance: 'outlined',
	message: undefined,
	ctaLabel: undefined,
	ctaAction: undefined
};

const pageLoaderStore = (
	options: PageLoaderOptions
): PageLoaderStore & Writable<PageLoaderOptions> => {
	const store = writable<PageLoaderOptions>(options);

	const open = (options?: Partial<PageLoaderOptions>) => {
		store.update(() => ({ ...pageLoaderOptionsDefault, ...options, isOpen: true }));
	};

	const close = () => {
		store.update(() => ({ ...pageLoaderOptionsDefault }));
	};

	return {
		...store,
		open,
		close
	};
};

export const pageLoader = pageLoaderStore(pageLoaderOptionsDefault);
